import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Container, Form} from "reactstrap";
import ReviewContactService from "../../../../services/reviewContactService";
import ReviewCompanyService from "../../../../services/reviewCompanyService";
import ReviewContactForm from "./Form";
import {contactRole} from "../../../../util/contactRole";
import _ from "lodash";
import UtilService from "../../../../services/utilService";

class ReviewContactEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            selectKey: UtilService.uuidv4()
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleContactRoleChange = this.handleContactRoleChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
    }

    async componentDidMount() {
        const {uniqueId} = this.props.match.params;
        await ReviewCompanyService.list().then(response => {
            this.setState({allCompanies: response});
        });
        ReviewContactService.fetch(uniqueId).then(response => {
            this.setState(response.data);
            this.setState({})
            this.setState({uniqueId: uniqueId});
            this.setState({selectedContactRole: {key: response.data.contactRole, value: response.data.contactRole}});
            this.setState({selectedCompany: response.data.company});
            this.setState({companyId: response.data.company.uniqueId});
            this.setState({contactRole: response.data.contactRole});
            this.setState({selectKey: UtilService.uuidv4()});
        });
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        ReviewContactService.update(this.state).then(response => {
            if (response.responseStatus === "SUCCESS") {
                this.props.history.push("/user/contact/list");
            } else {
                this.setState({errorData: response.data});
                console.error("Error    ==>     " + response.message);
            }
        });
    }

    handleContactRoleChange(valueObj) {
        if (_.isNull(valueObj)) {
            this.setState({selectedContactRole: {}, contactRole: ""});
        } else {
            this.setState({selectedContactRole: valueObj, contactRole: valueObj.key});
        }
    }

    handleCompanyChange = (valueObj, event) => {
        console.log(valueObj);
        if (_.isNull(valueObj)) {
            this.setState({selectedCompany: {}, companyId: ""});
        } else {
            this.setState({selectedCompany: valueObj, companyId: valueObj.uniqueId});
            this.setState({selectKey: UtilService.uuidv4()});
            console.log(this.state.companyId)
            console.log(this.state)
        }
    };

    render() {
        return (
            <>
                <SimpleHeader
                    name="Edit"
                    parentName="Review Contact"
                    heading="XareGrowth"
                    newBtnUrl="/user/contact/create"
                    newBtnText="Create Contact"
                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Edit Contact</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <ReviewContactForm
                                    selectKey={this.state.selectKey}
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                    isEdit={false}
                                    onContactRoleChange={this.handleContactRoleChange}
                                    selectedContact={this.state.selectedContactRole}
                                    contactRoles={contactRole}
                                    onCompanyChange={this.handleCompanyChange}
                                    selectedCompany={this.state.selectedCompany}
                                    companies={this.state.allCompanies}
                                />
                                <div className="text-center">
                                    <Button className="my-4" color="default" outline type="submit">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default ReviewContactEdit;
